import { Entity } from '@backstage/catalog-model';
import { z } from 'zod';
import { makeFieldSchema } from '../../../extensions/types';

/**
 * @public
 */
export const EntityRelationsPickerFieldSchema = makeFieldSchema({
  output: zoid => zoid.string(),
  uiOptions: zoid =>
    zoid.object({
      allowArbitraryValues: zoid
        .boolean()
        .optional()
        .describe('Whether to allow arbitrary user input. Defaults to true'),
      'ui:widget': zoid
        .string()
        .optional()
        .describe('The widget to use for the field'),
    }),
});

/**
 * The input props that can be specified under `ui:options` for the
 * `EntityRelationsPicker` field extension.
 *
 * @public
 */
export type EntityRelationsPickerUiOptions = NonNullable<
  typeof EntityRelationsPickerFieldSchema.TProps.uiSchema['ui:options']
>;

export type EntityRelationsPickerProps =
  typeof EntityRelationsPickerFieldSchema.TProps;

export const EntityRelationsPickerSchemaZod = z.object({
  schema: z.object({
    returnFormat: z.enum(['urn', 'ref']).optional(),
    relation: z.string().optional(),
  }),
  uiSchema: z.object({
    'ui:fieldName': z.string(),
    'ui:property': z.string().optional(),
    'ui:componentsFilter': z.string().optional(),
    'ui:filters': z
      .array(
        z.object({
          key: z.string(),
          value: z.string(),
        }),
      )
      .optional(),
  }),
});

export type EntityRelationsPickerSchema = z.infer<
  typeof EntityRelationsPickerSchemaZod
>;

export interface EntityRelationsPickerOptions {
  field: {
    name: string;
    path?: string;
  };
  relation: string;
  returnFormat: 'urn' | 'ref';
  filters: ((entity: Entity) => boolean)[];
}
